import { api } from '../api';
import type { TodoTask } from '../types';

export const addTask = (taskData: Omit<TodoTask, 'id' | 'createdAt'>) => api.tasks.add(taskData);
export const toggleTask = (taskId: string, completed: boolean) => api.tasks.toggle(taskId, completed);
export const deleteTask = (taskId: string) => api.tasks.delete(taskId);
export const getGroupTasks = (groupId: string) => api.tasks.getGroupTasks(groupId);
export const subscribeToGroupTasks = (groupId: string, callback: (tasks: TodoTask[]) => void) => api.tasks.subscribe(groupId, callback);
